import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel, SelectQuestionModel } from '../../../viewmodels/policy-item.model';
import { PayParkingCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'pay-parking-policy',
  templateUrl: './pay-parking.component.html',
})
export class PayParkingComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = PayParkingCopy;

  payPhoneRadio = new RadioQuestionModel();
  payPhoneSelect = new SelectQuestionModel();
  payAccountRadio = new RadioQuestionModel();
  payAccountSelect = new SelectQuestionModel();
  parkedWrongRadio = new RadioQuestionModel();
  parkedWrongSelect = new SelectQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setPayPhoneRadioQuestion();
    this.setPayPhoneSelectQuestion();
    this.setPayAccountRadioQuestion();
    this.setPayAccountSelectQuestion();
    this.setParkedWrongRadioQuestion();
    this.setParkedWrongSelectQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setPayPhoneRadioQuestion() {
    this.payPhoneRadio.data = {
      title: this.textCopy.payPhoneRadioTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onPayPhoneRadioQuestionSelected(answerValue) {
    this.payPhoneRadio.valueSelected = answerValue;
  }

  setPayPhoneSelectQuestion() {
    this.payPhoneSelect.data = {
      title: this.textCopy.payPhoneSelectTitle,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onPayPhoneSelectQuestionSelected(answerValue) {
    this.payPhoneSelect.valueSelected = answerValue;
  }

  setPayAccountRadioQuestion() {
    this.payAccountRadio.data = {
      title: this.textCopy.payAccountRadioTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onPayAccountRadioQuestionSelected(answerValue) {
    this.payAccountRadio.valueSelected = answerValue;
  }

  setPayAccountSelectQuestion() {
    this.payAccountSelect.data = {
      title: this.textCopy.payAccountSelectTitle,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onPayAccountSelectQuestionSelected(answerValue) {
    this.payAccountSelect.valueSelected = answerValue;
  }

  setParkedWrongRadioQuestion() {
    this.parkedWrongRadio.data = {
      title: this.textCopy.parkedWrongRadioTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'yes – provided they parked in our borough, not a neighbouring borough',
          value: 'p',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onParkedWrongRadioQuestionSelected(answerValue) {
    this.parkedWrongRadio.valueSelected = answerValue;
  }

  setParkedWrongSelectQuestion() {
    this.parkedWrongSelect.data = {
      title: this.textCopy.parkedWrongSelectTitle,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onParkedWrongSelectQuestionSelected(answerValue) {
    this.parkedWrongSelect.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.payPhoneRadio.valueSelected = this.policiesAnswers['26_1_1'];
    this.payPhoneSelect.valueSelected = this.policiesAnswers['26_1_2'];
    this.payAccountRadio.valueSelected = this.policiesAnswers['26_2_1'];
    this.payAccountSelect.valueSelected = this.policiesAnswers['26_2_2'];
    this.parkedWrongRadio.valueSelected = this.policiesAnswers['26_3_1'];
    this.parkedWrongSelect.valueSelected = this.policiesAnswers['26_3_2'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '26_1_1', description: this.payPhoneRadio.valueSelected },
      { id: '26_1_2', description: this.payPhoneSelect.valueSelected },
      { id: '26_2_1', description: this.payAccountRadio.valueSelected },
      { id: '26_2_2', description: this.payAccountSelect.valueSelected },
      { id: '26_3_1', description: this.parkedWrongRadio.valueSelected },
      { id: '26_3_2', description: this.parkedWrongSelect.valueSelected },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
